import { Button } from '@Components/Button';
import { Appearance, Size } from '@src/Components/designConstants';
import { CpsReportDetailsResponse } from './cps-utils';

interface ReportListItemProps {
  report: CpsReportDetailsResponse;
  onView: (reportId: string) => void;
}

const ReportListItem = ({ report, onView }: ReportListItemProps) => (
  <div className='cps-report-list-item'>
    <div className='cps-report-list-item-info'>
      <span className='cps-report-list-item-name'>{report.user?.name ?? 'Unknown'}</span>
      <span className='cps-report-list-item-period'>
        {report.periodStartDate} — {report.periodEndDate}
      </span>
      <span className='cps-report-list-item-hours'>{report.totalHoursWorked.toFixed(1)} hours</span>
    </div>
    <Button size={Size.LG} appearance={Appearance.OUTLINED} onClick={() => onView(report.id)}>
      View Report
    </Button>
  </div>
);

export { ReportListItem };
